<template>
  <div id="expert-answer" class="listStyle">
    <div id="goToHere2"></div>
    <SearchBox
      v-show="flag"
      ref="searchBox"
      @searchKeyWord="searchKeyWord"
      @selectTime="selectTime"
      @clearTime="clearTime"
    ></SearchBox>
     <!-- 列表组件 -->
    <list-content
      ref="listContent"
      :lists="lists"
      :total="total"
      :totalLists="totalLists"
    ></list-content>
    <!-- 分页 -->
    <div v-if="lists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :totalLists="totalLists"
        @prevPage="prevPage"
        @nextPage="nextPage"
      ></Pagination>
    </div>
    <van-overlay :showLoding="showLoding"></van-overlay>
  </div>
</template>

<script>
import SearchBox from "@/components/common/search";
import ListContent from "@/components/common/listContent";
import Tabbar from "@/components/common/tabbar";
import Pagination from "@/components/common/pagination"; // 分页
export default {
   data () {
    return {
      flag: true,
      searchText: "",
      SearchTimes: 1, // 查询次数
      currentPage: 1,
      stime: "",
      etime: "",
      lists: [],
      showLoding: false,
      total: 0,
      totalLists: 0, // 总的条数
    }
  },
  components: {
    SearchBox,
    ListContent,
    Tabbar,
    Pagination
  },
  created () {
    this.getData()
  },
  methods: {
    goPolicyMate() {
      window.location.href = 'http://test.holywiser.com/policyMate'
      //this.$router.push({name:"PolicyMate"})
    },
    // 搜索关键词
    searchKeyWord(keyword) {
      this.searchText = keyword;
      this.SearchTimes = 1;
      this.currentPage = 1;
      this.$refs.listContent.toggle([]);
      this.getData();
    },
    // 选择时间
    selectTime(time) {
      this.stime = time.stime;
      this.etime = time.etime;
      this.currentPage = 1;
      this.getData()
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 清除时间按钮
    clearTime() {
      this.SearchTimes = 1;
      this.stime = '';
      this.etime = '';
      this.currentPage = 1;
      this.getData();
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 恢复选择的状态
    backStatus() {
      this.$store.commit("choose/setFlag1", false);
    },
    getData() {
      //console.log("888====》");
      let argsAnswer = {
        searchtimes: 1,
        frist: {
          text: this.searchText && this.searchText !== "" ? this.searchText : "",
          potence: "",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode
          },
          dirid: "",
          id: "",
          stime: this.stime && this.stime !== "" ? this.stime : "",
          etime: this.etime && this.etime !== "" ? this.etime : "",
        },
        second: [],
        fliter: {
          isfilter: false,
          tagpc: [],
          tagid: "",
        },
        pager: [
          {
            pagesize: 10, // 每页显示的条数
            pageindex: this.currentPage, // 当前页
          },
        ],
        scencs: "taxnews"
      };
      
      let nodes = this.$baseConfig.code;
      this.$http.reqGetLocalLastFiles(argsAnswer, nodes)
          .then((response) => {
            if(response.rtncode === 1){
              if(response.rltcode === 1) {
                console.log("expert~", response);
                this.showLoding = false;
                this.lists =
                response.tbls[0].items !== null ? response.tbls[0].items : [];
                this.total = Math.ceil(response.tbls[0].total / 10);
                this.totalLists = response.tbls[0].total; // 总的条数
                this.$store.commit(
                  "search/setIsProtect",
                  response.tbls[0].protect
                );
                this.$store.commit(
                  "search/setWarningLevel",
                  response.tbls[0].warninglevel
                );
                this.$store.commit(
                  "search/setWarningText",
                  response.tbls[0].warningtext
                );
                this.$store.dispatch("choose/updateLists", this.lists);

              } else {
                warningNotify(response.rltdesc, this);
                this.showLoding = false;
              }
            }else {
              warningNotify(response.rtndesc, this);
              this.showLoding = false;
            }
          })
    },
    // 点击上一页
    prevPage() {
      if (this.currentPage == 1) return;
      this.currentPage--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    },
    // 点击下一页
    nextPage() {
      if (this.currentPage == this.total) return;
      this.currentPage++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    },
  }
}
</script>

<style lang="less" scoped>
#expert-answer{
  height:calc(100vh - 115px);
  overflow-y: auto;
  .pageBoxStyle {
    width: 100%;
    position: fixed;
    bottom: 2px;
    left: 0;
    font-size: 0.37333rem;
    flex: 0 0 50px;
    background-color: #fff;
  }
}
</style>